import React, { useEffect, useState } from 'react';
import styles from './Analytics.module.css';
import { useSelector } from 'react-redux';
import GraphOptions from './GraphOptions';
import { SENSORS, TIME_PRESETS } from '../../config';
import SensorsGraph from '../SharedGraphs/SensorsGraph';
import { Notify } from 'notiflix';
import { useTokenCheck } from '../../hooks/useTokenCheck';
import KeyDataPoints from './KeyDataPoints';

export default function Analytics() {
  useTokenCheck();
  const systems = useSelector((state) => state.bessReducer.overview.systems);
  const [selectedSystem, setSelectedSystem] = useState(systems[0]);
  const selectedSystemDetails = useSelector(
    (state) => state.bessReducer.details[selectedSystem.id]
  );
  const [detailLevel, setDetailLevel] = useState('System');
  const [toDateTime, setToDateTime] = useState(new Date());
  const intermediateFromDateTime = new Date(toDateTime.getTime());
  intermediateFromDateTime.setHours(intermediateFromDateTime.getHours() - 24);
  const [fromDateTime, setFromDateTime] = useState(intermediateFromDateTime);
  const [sensorToGraph, setSensorToGraph] = useState(SENSORS.Voltage);

  const sensors = [];
  let detailLevelSensors;
  if (detailLevel === 'System') {
    detailLevelSensors = selectedSystemDetails.sensors.map((sensor) => ({
      ...sensor,
      ids: [sensor.deviceSensorId]
    }));
  } else if (detailLevel === 'Cell') {
    const sensorsWithIds = {
      [SENSORS.Voltage.name]: {
        sensorTypeName: SENSORS.Voltage.name,
        ids: []
      },
      [SENSORS.InternalResistance.name]: {
        sensorTypeName: SENSORS.InternalResistance.name,
        ids: []
      }
    };
    selectedSystemDetails.cabinets.forEach((cabinet) => {
      cabinet.modules.forEach((module) => {
        module.cells.forEach((cell) => {
          cell.sensors.forEach((sensor) => {
            sensorsWithIds[sensor.sensorTypeName].ids.push(
              sensor.deviceSensorId
            );
          });
        });
      });
    });

    detailLevelSensors = Object.values(sensorsWithIds);
  }

  sensors.push(
    ...detailLevelSensors.map((sensor) => ({
      ...SENSORS[sensor.sensorTypeName],
      ids: sensor.ids
    }))
  );

  const [currentGraphSystemId, setCurrentGraphSystemId] = useState(
    selectedSystem.id
  );
  const [currentGraphSensors, setCurrentGraphSensors] = useState(sensors);
  const [currentGraphSensor, setCurrentGraphSensor] = useState(sensorToGraph);
  const [currentGraphToDate, setCurrentGraphToDate] = useState(toDateTime);
  const [currentGraphFromDate, setCurrentGraphFromDate] =
    useState(fromDateTime);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (refresh) {
      setCurrentGraphSystemId(selectedSystem.id);
      setCurrentGraphSensors(sensors);
      setCurrentGraphSensor(sensorToGraph);
      setCurrentGraphToDate(toDateTime);
      setCurrentGraphFromDate(fromDateTime);
      setRefresh(false);
      Notify.success('Applied');
    }
  }, [refresh]);

  return (
    <div className={styles.mainGraphCard}>
      <GraphOptions
        selectedSystem={selectedSystem}
        setSelectedSystem={setSelectedSystem}
        detailLevel={detailLevel}
        setDetailLevel={setDetailLevel}
        onApplyClicked={() => {
          setRefresh(true);
        }}
        fromDateTime={fromDateTime}
        setFromDateTime={setFromDateTime}
        toDateTime={toDateTime}
        setToDateTime={setToDateTime}
        selectedSensor={sensorToGraph}
        setSelectedSensor={setSensorToGraph}
      />
      <div className={styles.content}>
        <KeyDataPoints systemId={selectedSystem.id} />
        <div className={styles.graphContainer}>
          <SensorsGraph
            showDots={true}
            systemId={currentGraphSystemId}
            sensors={currentGraphSensors}
            sensorToGraph={currentGraphSensor}
            toDate={currentGraphToDate}
            fromDate={currentGraphFromDate}
            height={'65vh'}
            timePreset={TIME_PRESETS.free}
          />
        </div>
      </div>
    </div>
  );
}
